<template>
  <div class="form-box">
    <el-form :model="obj" :rules="formRules" ref="sampleForm" label-width="90px" class="order-sample-ruleForm">
      <el-row type="flex" justify="start" align="middle" style="width:100%;flex-wrap:wrap;">
        <el-col :span="24">
          <el-form-item label="国家" prop="ServiceCountry">
            <el-select style="width:100%" v-model="obj.ServiceCountry" placeholder="请选择国家" clearable filterable
              popper-class="relative-select" :popper-append-to-body="false">
              <el-option v-for="item in CrossBorderServiceCountry" :label="item.ItemName" :value="item.ItemValue">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="公司名称" prop="CompanyName">
            <el-input v-model="obj.CompanyName" placeholder="请输入公司名称">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="msg-box">
      <h4 class="text-error">

      </h4>
    </div>
  </div>
</template>

<script>
import { GetItemDetailList, GetList } from "@/api/general-api"

export default {
  name: 'BrandOtherEdit',
  data() {
    var validateExpressNum = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入快递单号'));
      } else {
        if (/[\u4E00-\u9FA5]/g.test(value)) {
          callback(new Error('快递单号不能输入汉字!'));
        } else {
          callback();
        }
      }
    };
    return {
      dialogVisible: false,
      currentRow: null,
      CrossBorderServiceCountry: [],
      BrandServiceType: [],
      expressInformationBoolean: true,
      obj: {
        CompanyName: null,
      },
      formRules: {
        CompanyName: [
          { required: true, message: '请输入公司名称', trigger: 'blur' },
        ],
        VATTax: [
          { required: true, message: '请输入VAT税号', trigger: 'blur' },
        ],
        ServiceCountry: [
          { required: true, message: '请选择国家', trigger: 'change' },
        ],
      },
      myAddressList: []
    }
  },
  created() {
    GetItemDetailList({ ItemCode: 'CrossBorderServiceCountry' }).then(res => {
      if (res.success) {
        this.CrossBorderServiceCountry = res.data
      }
    })
    GetItemDetailList({ ItemCode: 'BrandServiceType' }).then(res => {
      if (res.success) {
        this.BrandServiceType = res.data
      }
    })
    this.handleGetList()
  },
  methods: {
    onAddressTableRowClick(row) {
      this.currentRow = row;
    },
    OnOpenAddressList() {
      this.dialogVisible = true;
    },
    onArressSelected() {
      if (!this.currentRow) {
        return this.$message.error("请先选择一行地址信息！");
      }

      this.obj.BackLinker = this.currentRow.Linker
      this.obj.BackLinkTel = this.currentRow.LinkTel
      this.obj.BackAddress = this.currentRow.Address
      this.dialogVisible = false;
    },
    GetData() {
      let _b = true
      this.$refs.sampleForm.validate((valid) => {
        _b = _b && valid
      })
      if (_b) {
        return { ...this.obj }
      }
    },
    handleGetList() {
      const queryParam = {
        Name: 'UserAddress',
        currentPage: 1,
        pageSize: 999,
        orderField: 'CreateTime',
        orderType: 'descend'
      }
      GetList(queryParam).then((res) => {
        if (res.success) {
          this.myAddressList = res.data.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
  },

}
</script>

<style lang="scss">
.el-dialog.address-select-wnd {
  margin-top: 20vh !important;
}

.form-box {
  padding: 0px;
}

.order-sample-ruleForm {
  border: 1px solid #f0f0f0;
  padding: 10px;

  .el-form-item {
    margin-bottom: 12px!important;
  }

  .el-descriptions-item__cell {
    padding: 0px 5px !important;
  }

  .required {
    &::after {
      content: "*";
      color: #c10015;
      font-size: 20px;
      font-weight: bold;
    }
  }
}

.msg-box {
  margin: 30px 0;
  padding: 10px 20px;
  background: #f0f0f0;
}
</style>